var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as _ from "lodash";
import moment from "moment";
import { getAggregateStatus, parseExperiment } from "./AudienceStage.utils.js";
import { DEFAULT_SEARCH_PAGE_SIZE, ALL_EXPERIMENTS, ALL_EXPERIMENT_GROUPS } from "../FeatureSearchConstants.js";
import { getExperimentationPathFromId } from "@ane/exp-data/lib/utils/ManagementGroup/ManagementGroup.utils";
const convertFeatures = (featureResults) => {
  return featureResults && _.map(featureResults.value, (f) => convertFeature(f)) || [];
};
const convertFeature = (featureDto) => {
  const createdDateTime = moment(featureDto.createdTime);
  const startDateTime = getStartDate(featureDto);
  return {
    id: featureDto.id,
    name: featureDto.displayName,
    description: featureDto.description,
    experimentationGroup: getExperimentationPathFromId("", featureDto.experimentationGroup),
    status: getStatus(featureDto),
    variants: getFormattedVariants(featureDto),
    startDateTime,
    createdDateTime
  };
};
const getStatus = (feature) => {
  return getAggregateStatus(feature.experiments.map((e) => parseExperiment(e).status));
};
const defaultFeatureFilterOptions = {
  top: DEFAULT_SEARCH_PAGE_SIZE,
  isArchived: false,
  orderBy: "createdDateTime desc"
};
const getFeatureFilters = (args) => {
  const { toDate, fromDate, managementGroup, pivot } = args || {};
  const toDateFormatted = getFormattedDateTime(toDate);
  const fromDateFormatted = getFormattedDateTime(fromDate);
  return __spreadValues({
    status: pivot && pivot !== ALL_EXPERIMENTS ? pivot : void 0,
    experimentationGroup: managementGroup && managementGroup !== ALL_EXPERIMENT_GROUPS ? managementGroup : void 0,
    toDateTime: toDateFormatted,
    fromDateTime: fromDateFormatted
  }, defaultFeatureFilterOptions);
};
const getFormattedDateTime = (value) => {
  const dateMoment = value ? moment(value) : void 0;
  const dateFormatted = (dateMoment == null ? void 0 : dateMoment.isValid()) ? dateMoment.format("MM/DD/YYYY") : void 0;
  return dateFormatted;
};
const getFormattedVariants = (featureDto) => {
  if (!featureDto.variants) {
    return [];
  }
  const flagString = (variant, namespace, flagValue, flagName) => `${variant.displayName} | ${namespace}.${flagName}:${flagValue}`;
  return _.flatten(
    _.map(
      featureDto.variants,
      (variant) => _.size(variant.featureFlags) > 0 ? _.map(
        variant.featureFlags,
        (flags, namespace) => _.map(flags, (flagValue, flagName) => flagString(variant, namespace, flagValue, flagName)).join("; ")
      ) : `${variant.displayName}`
    )
  );
};
const getStartDate = (featureDto) => {
  const startedAtList = _.flatten(
    _.map(featureDto.experiments, (experiment) => _.map(experiment.experimentSteps, (step) => step.startedAt))
  ).filter((l) => l != null).map((l) => moment(l));
  if (startedAtList.length > 0) {
    return moment.min(startedAtList);
  }
  return void 0;
};
const applyFeatureFilters = (features, keyword, statusFilters, experimentationGroupFilters) => {
  let filteredItems = features;
  if (!!statusFilters.length || !!experimentationGroupFilters.length || !!keyword) {
    filteredItems = _.filter(
      features,
      (i) => (!keyword || i.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1 || !!i.description && i.description.toLowerCase().indexOf(keyword.toLowerCase()) !== -1 || i.variants.join(" ").toLowerCase().indexOf(keyword.toLowerCase()) !== -1) && (!statusFilters.length || statusFilters.includes(i.status)) && (!experimentationGroupFilters.length || experimentationGroupFilters.includes(i.experimentationGroup))
    );
  }
  return filteredItems;
};
export {
  applyFeatureFilters,
  convertFeature,
  convertFeatures,
  defaultFeatureFilterOptions,
  getFeatureFilters,
  getFormattedVariants,
  getStartDate,
  getStatus
};
//# sourceMappingURL=FeatureListUtils.js.map
